import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  absoluteFromRelativeUrl,
  projectTaskPath,
} from '../../../cross-team-shared/hub-paths';
import { EventTrackingService } from '../../../shared/event-tracking/event-tracking.service';
import { TaskWorkspaceStore } from '../../h3ml/state/task-workspace-store';

@Component({
  selector: 'h3-multi-tabs-opened-modal',
  templateUrl: './multi-tabs-opened-modal.component.html',
  styleUrls: ['./multi-tabs-opened-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MultiTabsOpenedModalComponent {
  isMultipleTabsAllowed = !this.store.isUsingObjects();
  taskId$ = this.store('task')('id').$;

  constructor(
    private store: TaskWorkspaceStore,
    private eventTrackingService: EventTrackingService,
  ) {}

  getTaskUrl() {
    const { project, task } = this.store.state();
    return absoluteFromRelativeUrl(projectTaskPath(project, task));
  }

  trackEvent() {
    this.eventTrackingService.track({
      id: 'multiple_production_workspaces',
      bucket: 'untracked',
      action: 'proceed_anyway',
    });
  }
}
